<template>
  <v-layout row wrap>
    <v-flex xs12>
        <v-form ref="formSegurosAnteriores" v-model="formValidSegurosAnteriores">
            <v-layout row wrap>
                <v-flex xs12 sm5>
                    <h4 class="primary--text">Possui apólice anterior de seguro de cargas?*</h4>
                    <v-radio-group required :rules="regras.apoliceAnteriores" v-model="apoliceAnterioresStr" row>
                        <v-radio color="primary" id="chkSimSegurosAnterioresApolicesAnteriores" ref="chkSimSegurosAnterioresApolicesAnteriores" label="Sim" value="true"></v-radio>
                        <v-radio color="primary" id="chkNaoSegurosAnterioresApolicesAnteriores" ref="chkNaoSegurosAnterioresApolicesAnteriores" label="Não" value="false"></v-radio>
                    </v-radio-group>
                </v-flex>
                <v-flex sm7 v-if="!$vuetify.breakpoint.xsOnly"></v-flex>
                <template>
                    <v-flex xs12 v-show="segurosAnteriores.apoliceAnteriores && apoliceAnterioresStr">
                        <v-flex xs12 sm6>
                            <v-text-field 
                            id="txtSegurosAnterioresSeguradora" 
                            ref="txtSegurosAnterioresSeguradoraRef" 
                            v-model="segurosAnteriores.seguradora" 
                            label="Seguradora*" 
                            :rules="regras.seguradora" 
                            required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-text-field 
                            id="txtSegurosAnterioresCorretora" 
                            ref="txtSegurosAnterioresCorretoraRef" 
                            v-model="segurosAnteriores.corretora" 
                            label="Corretora" 
                            :rules="regras.corretora"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm4>
                            <v-menu
                                ref="modalDataVencimento"
                                lazy
                                :close-on-content-click="false"
                                v-model="modalDataVencimento"
                                transition="scale-transition"
                                offset-y
                                full-width
                                :nudge-right="40"
                                min-width="290px"
                                :return-value.sync="segurosAnteriores.vencimento">
                                <v-text-field
                                slot="activator"
                                label="Vencimento"
                                v-model="modelFormatado.dataVencimento"
                                prepend-icon="event"
                                id="txtSegurosAnterioresVencimento"
                                readonly
                                ></v-text-field>
                                <v-date-picker v-model="segurosAnteriores.vencimento" 
                                locale="pt-br"
                                @input="$refs.modalDataVencimento.save(segurosAnteriores.vencimento)"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex sm8 v-if="!$vuetify.breakpoint.xsOnly"></v-flex>
                        <v-flex xs12 sm5>
                        <h4 class="primary--text">Informe o valor da taxa ou do desconto no seguro anterior*</h4>
                            <v-radio-group required ref="taxaDescontoAnteriorRadioRef" :rules="regras.taxaDescontoAnteriorRadio" v-model="taxaDescontoAnteriorRadioStr" @change="zeraTaxaDescontoAnteriorTextField()" row>
                                <v-radio color="primary" id="chkTaxaSegurosAnteriores" label="Taxa" value="taxa"></v-radio>
                                <v-radio color="primary" id="chkDescontoSegurosAnteriores" label="Desconto" value="desconto"></v-radio>
                            </v-radio-group>
                        </v-flex>
                        <template>
                            <v-flex sm7 v-show="taxaDescontoAnteriorRadioStr == 'taxa'"></v-flex>
                            <v-flex xs12 sm4 v-show="taxaDescontoAnteriorRadioStr == 'taxa'">
                                <v-text-field label="Taxa*"
                                ref="txtSegurosAnterioresTaxaApoliceAnteriorLabel"
                                id="txtSegurosAnterioresTaxaApoliceAnterior"
                                :rules="regras.porcentagemTaxa"
                                validate-on-blur
                                v-model.lazy="modelFormatado.taxaApoliceAnterior"
                                maxlength="7"
                                hint="Informe a taxa com 3 casas decimais no máximo"
                                ></v-text-field>
                            </v-flex>
                        </template>
                        <template>
                            <v-flex sm7 v-show="taxaDescontoAnteriorRadioStr == 'desconto'"></v-flex>
                            <v-flex xs12 sm4 v-show="taxaDescontoAnteriorRadioStr == 'desconto'">
                                <v-text-field label="Desconto*"
                                ref="txtSegurosAnterioresDescontoApoliceAnteriorLabel"
                                id="txtSegurosAnterioresDescontoApoliceAnterior"
                                :rules="regras.porcentagemDesconto"
                                hint="Informe o desconto com 2 casas decimais no máximo"
                                validate-on-blur
                                v-model.lazy="modelFormatado.descontoApoliceAnterior"
                                maxlength="6"
                                ></v-text-field>
                            </v-flex>
                        </template>
                        <v-flex sm8 v-if="!$vuetify.breakpoint.xsOnly"></v-flex>
                        <v-flex xs12 sm5>
                        <h4 class="primary--text">Cobertura de roubo?*</h4>
                            <v-radio-group required ref="taxaRouboAnteriorRadioRef" :rules="regras.coberturaRoubo" v-model="coberturaRouboStr" row>
                                <v-radio color="primary" id="chkSimSegurosAnterioresCoberturaRoubo" label="Sim" value="true"></v-radio>
                                <v-radio color="primary" id="chkNaoSegurosAnterioresCoberturaRoubo" label="Não" value="false"></v-radio>
                            </v-radio-group>
                        </v-flex>
                        <v-flex sm7 v-if="!$vuetify.breakpoint.xsOnly"></v-flex>
                        <template>
                            <v-flex xs12 sm4 v-show="segurosAnteriores.coberturaRoubo && coberturaRouboStr">
                                <v-text-field label="Taxa*"
                                ref="txtSegurosAnterioresTaxaRouboApoliceAnteriorRef"
                                id="txtSegurosAnterioresTaxaRouboApoliceAnterior"
                                :rules="regras.porcentagemTaxa"
                                hint="Informe a taxa com 3 casas decimais no máximo"
                                validate-on-blur
                                v-model.lazy="modelFormatado.taxaRouboApoliceAnterior"
                                maxlength="7"
                                ></v-text-field>
                            </v-flex>
                            <v-flex sm8 v-if="!$vuetify.breakpoint.xsOnly" v-show="segurosAnteriores.coberturaRoubo && coberturaRouboStr"></v-flex>
                        </template>
                    </v-flex>
                </template>
                <v-flex xs12 sm5>
                    <h4 class="primary--text">Houve ocorrência de Sinistros?*</h4>
                    <v-radio-group required :rules="regras.ocorreuSinistro" v-model="ocorreuSinistroStr" row>
                        <v-radio color="primary" id="chkSimSegurosAnterioresOcorreuSinistro" label="Sim" value="true"></v-radio>
                        <v-radio color="primary" id="chkNaoSegurosAnterioresOcorreuSinistro" label="Não" value="false"></v-radio>
                    </v-radio-group>
                </v-flex>
                <v-flex sm7 v-if="!$vuetify.breakpoint.xsOnly"></v-flex>
                <template v-if="segurosAnteriores.ocorreuSinistro && ocorreuSinistroStr">
                    <v-flex xs12>
                        <v-card>
                            <v-toolbar height="56" color="primary" class="overflow-toolbar">
                                <v-toolbar-title class="subheading white--text">Sinistros <br/> <small>Eventos dos últimos 12 meses</small></v-toolbar-title>
                            </v-toolbar>
                        </v-card>
                        <v-container grid-list-lg>
                            <v-layout row wrap>
                                <v-flex xs12 v-if="segurosAnteriores.sinistros.length == 0"><small class="error--text">Informe ao menos um sinistro *</small></v-flex>
                                <v-flex xs12 sm2>
                                    <v-text-field label="Valor do prejuízo*"
                                    ref="txtValorSinistro"
                                    id="txtSegurosAnterioresValorSinistro"
                                    validate-on-blur
                                    :error-messages="errorMessages.valorPrejuizo"
                                    :rules="regras.valorPrejuizo"
                                    v-model.lazy="modelFormatado.valorPrejuizoSinistro"
                                    v-money="maskMoney"
                                    required></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm4>
                                    <v-autocomplete label="Mercadoria*"
                                    id="txtSegurosAnterioresMercadoriaSinistro"
                                    v-model="modelSinistro.mercadoria"
                                    :items="lstMercadorias"
                                    :error-messages="errorMessages.mercadoria"
                                    item-text="descricao"
                                    return-object
                                    validate-on-blur
                                    required></v-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm4>
                                    <v-autocomplete label="Causa do Sinistro*"
                                    id="txtSegurosAnterioresCausaSinistro"
                                    :items="lstOpcoesCausaDoSinistro"
                                    item-text="causaDoSinistro"
                                    item-value="causaDoSinistro"
                                    :error-messages="errorMessages.causaDoSinistro"
                                    v-model="modelSinistro.causaDoSinistro"
                                    validate-on-blur
                                    required
                                    ></v-autocomplete>
                                </v-flex>
                                <!-- <v-flex xs12 sm4>
                                    <v-autocomplete label="UF*" required
                                    id="estadoSelectorSinistro"
                                    :error-messages="errorMessages.estado"
                                    v-model="modelSinistro.estado"
                                    :items="estados"
                                    item-text="sigla"
                                    return-object>
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs12 sm4>
                                    <v-autocomplete label="Cidade*" required
                                    id="cidadeSelectorSinistro"
                                    :error-messages="errorMessages.cidade"
                                    v-model="modelSinistro.cidade"
                                    :items="cidades"
                                    item-text="nome"
                                    return-object>
                                    </v-autocomplete>
                                </v-flex> -->
                                <v-flex xs12 sm2>
                                    <v-menu
                                        ref="modalDataSinistro"
                                        lazy
                                        :close-on-content-click="false"
                                        v-model="modalDataSinistro"
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        :nudge-right="40"
                                        min-width="290px"
                                        :return-value.sync="modelSinistro.data">
                                        <v-text-field
                                        slot="activator"
                                        label="Data*"
                                        v-model="modelFormatado.dataSinistro"
                                        prepend-icon="event"
                                        id="txtSegurosAnterioresDataSinistro"
                                        required
                                        validate-on-blur
                                        readonly
                                        :error-messages="errorMessages.data"
                                        ></v-text-field>
                                        <v-date-picker 
                                        v-model="modelSinistro.data"
                                        :max="(new Date()).toISOString().substring(0, 10)"
                                        locale="pt-br"
                                        @input="$refs.modalDataSinistro.save(modelSinistro.data)"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <!-- <v-flex xs12 sm9>
                                    <v-textarea label="Observação*" required
                                    id="txtObsSinistro"
                                    :error-messages="errorMessages.obs"
                                    v-model="modelSinistro.obs"
                                    counter="150">
                                    </v-textarea>
                                </v-flex> -->
                                <v-flex xs12 text-xs-right >
                                  <v-btn id="btnAdicionaSinistro" 
                                      @click="adicionaSinistro" 
                                      color="secondary"
                                      :block="$vuetify.breakpoint.xsOnly" 
                                      class="white--text" 
                                      :disabled="!sinistroValido">
                                        ADICIONAR
                                  </v-btn>
                                </v-flex>
                                
                                <v-flex sm4 v-if="!$vuetify.breakpoint.xsOnly"></v-flex>
                                <v-flex xs12>
                                    <v-data-table :headers="cabecalhoGridSinistros"
                                    :items="segurosAnteriores.sinistros"
                                    hide-actions
                                    no-data-text="Nenhum sinistro foi adicionado">
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left">{{ props.item.mercadoria.descricao }}</td>
                                            <td class="text-xs-left">{{ toMoneyString(props.item.valorPrejuizo) }}</td>
                                            <td class="text-xs-left">{{ props.item.causaDoSinistro }}</td>
                                            <!-- <td class="text-xs-left">{{ props.item.estado.sigla }}</td>
                                            <td class="text-xs-left">{{ props.item.cidade.nome }}</td> -->
                                            <td class="text-xs-left">{{ toLocaleDateString(props.item.data) }}</td>
                                            <!-- <td class="text-xs-left">{{ props.item.obs }}</td> -->
                                            <td><v-btn @click.stop="removeSinistro(props.item)" color="primary remove-sinistro" flat icon><v-icon>delete</v-icon></v-btn></td>
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>
                </template>
                <v-flex xs12>
                    <v-btn flat
                        :block="$vuetify.breakpoint.xsOnly" 
                        color="primary"
                        id="btnAnteriorSegurosAnteriores"
                        @click.native="elementoPai.passoAnterior()">
                            <v-icon left class="hidden-sm-and-down">chevron_left</v-icon>
                            Anterior
                    </v-btn>
                    <v-btn :disabled="!passoValido"
                        id="btnProximoSegurosAnteriores"
                        :block="$vuetify.breakpoint.xsOnly" 
                        color="primary white--text"
                        @click.native="elementoPai.proximoPasso()">
                            Próximo 
                            <v-icon right class="hidden-sm-and-down">chevron_right</v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import {VMoney} from 'v-money'
import CustomFormat from '@/helpers/custom-format'
import axios from 'axios'

export default {
  name: 'segurosanteriores',
  directives: {
    money: VMoney
  },
  data: () => {
    return {
        questionarioPai: {},
        dataHoraInicio: '',
        tempoPreenchimentoTotal: '',
        formValidSegurosAnteriores: false,
        formValidSegurosAnterioresSinistros: false,
        modalDataVencimento: false,
        modalDataSinistro: false,
        apoliceAnterioresStr: null,
        taxaDescontoAnteriorRadioStr: null,
        coberturaRouboStr: null,
        ocorreuSinistroStr: null,
        estados: [],
        cidades: [],
        lstOpcoesCausaDoSinistro: [
          {id: 1, causaDoSinistro: 'Acidente'},
          {id: 2, causaDoSinistro: 'Avaria'},
          {id: 3, causaDoSinistro: 'Roubo'}        
        ],
        modelFormatado: {
            dataVencimento: '',
            valorPrejuizoSinistro: 0.0,
            dataSinistro: '',
            taxaApoliceAnterior: 0.0,
            descontoApoliceAnterior: "0",
            taxaRouboApoliceAnterior: "0"
        },
        modelSinistro: {
            valorPrejuizo: 0.0,
            mercadoria: {},
            causaDoSinistro: '',
            data: '',
            estado: null,
            cidade: null,
            obs: null
        },
        segurosAnteriores: {
            apoliceAnteriores: null,
            seguradora: '',
            corretora: '',
            vencimento: '',
            ocorreuSinistro: null,
            sinistros: [],
          coberturaRoubo: null,
            taxaApoliceAnterior: 0.0,
            descontoApoliceAnterior: 0.0,
            taxaRouboApoliceAnterior: 0.0
        },
        lstMercadorias: [],
        cabecalhoGridSinistros: [
            { text: 'Mercadoria', value: 'mercadoria'},
            { text: 'Valor do prejuízo', value: 'valorPrejuizo'},
            { text: 'Causa do Sinistro', value: 'causaDoSinistro'},
            //{ text: 'UF', value: 'estado'},
            //{ text: 'Cidade', value: 'cidade'},
            { text: 'Data', value: 'data'},
            //{ text: 'Obs', value: 'obs'}
            {text: '', value: ''}
        ],
        errorMessages: {
            valorPrejuizo: [],
            mercadoria: [],
            causaDoSinistro: [],
            estado: [],
            cidade: [],
            data: [],
            obs: []
        },
        regras: {
            apoliceAnteriores: [
                v => !!v || 'Você não pode deixar este campo em branco'
            ],
            seguradora: [
              v => !!v || 'Você não pode deixar este campo em branco'
            ],
            corretora: [
              v => (!v || (!!v && (v.length == 0 || v.length <= 255))) || 'O campo deve ter no máximo 255 caracteres'
            ],
            taxaDescontoAnteriorRadio: [
              v => !!v || 'Você não pode deixar este campo em branco'
            ],
            ocorreuSinistro: [
              v => !!v || 'Você não pode deixar este campo em branco'
            ],
            porcentagemTaxa: [
              v => (CustomFormat.removePercentFormat(v) >= 0) || 'Você precisa informar um valor válido',
                  v => (CustomFormat.removePercentFormat(v) <= 100) || 'Você precisa informar um valor válido',
                  v => (   (/^(100)$/g.test(v) && v.length < 8 )
                        || (/^(100\,\d{1,3})$/g.test(v) && v.length < 8 )
                        || (/^(\d{2})$/g.test(v) && v.length < 7)
                        || (/^(\d{2}\,\d{1,3})$/g.test(v) && v.length < 7)
                        || (/^(\d{1})$/g.test(v) && v.length < 6)
                        || (/^(\d{1}\,\d{1,3})$/g.test(v) && v.length < 6) )
                        || 'Você precisa informar um valor válido'
            ],
            porcentagemDesconto: [
              v => (CustomFormat.removePercentFormat(v) >= 0) || 'Você precisa informar um valor válido',
              v => (CustomFormat.removePercentFormat(v) <= 100) || 'Você precisa informar um valor válido',
              v => (   (/^(100)$/g.test(v) && v.length < 8 )
                    || (/^(100\,\d{1,2})$/g.test(v) && v.length < 8 )
                    || (/^(\d{2})$/g.test(v) && v.length < 6)
                    || (/^(\d{2}\,\d{1,2})$/g.test(v) && v.length < 6)
                    || (/^(\d{1})$/g.test(v) && v.length < 5)
                    || (/^(\d{1}\,\d{1,2})$/g.test(v) && v.length < 5) )
                    || 'Você precisa informar um valor válido'
            ],
            valorPrejuizo: [
              v => CustomFormat.removeMoneyFormat(v) > 0 || "Você precisa informar um valor válido"
            ],
          /*
            vencimento: [
                v => !!v || 'Você não pode deixar este campo em branco'
            ],*/
            descontoApoliceAnterior: [
                v => (CustomFormat.removePercentFormat(v) >= 0 &&
                      CustomFormat.removePercentFormat(v) <= 100) || 'Você precisa informar um desconto válido'
            ],
            taxaApoliceAnterior: [
                v => (CustomFormat.removePercentFormat(v) > 0 &&
                      CustomFormat.removePercentFormat(v) <= 100) || 'Você precisa informar uma taxa válida'
            ],
            coberturaRoubo: [
                v => !!v || 'Você não pode deixar este campo em branco'
            ],
            taxaRouboApoliceAnterior: [
                v => (CustomFormat.removePercentFormat(v) > 0 && 
                      CustomFormat.removePercentFormat(v) <= 100) || 'Você precisa informar uma taxa válida'
            ]
          
        },
        maskMoney: {
            decimal: ',',
            thousands: '.',
            prefix: 'R$ ',
            precision: 2,
            masked: false
        }
    }
  },
  computed: {
    elementoPai: function () {
      return this.$parent.$parent.$parent;
    },
    taxaApoliceAnteriorValid: function () {
        return this.segurosAnteriores.taxaApoliceAnterior > 0 && this.segurosAnteriores.taxaApoliceAnterior <= 100;
    },
    descontoApoliceAnteriorValid: function () {
        return this.segurosAnteriores.descontoApoliceAnterior > 0 && this.segurosAnteriores.descontoApoliceAnterior <= 100;
    },
    sinistroValido: function() {
      return this.modelSinistro.valorPrejuizo && this.modelSinistro.mercadoria && this.modelSinistro.causaDoSinistro && this.modelSinistro.data;
    },
    passoValido: function () {
        const self = this;
        let validaOcorrenciaSinistro = (self.segurosAnteriores.ocorreuSinistro && self.segurosAnteriores.sinistros.length > 0) || !self.segurosAnteriores.ocorreuSinistro;
        if (self.apoliceAnterioresStr == 'true'){        
            self.formValidSegurosAnteriores = 
                self.segurosAnteriores.seguradora != "" && 
                self.segurosAnteriores.corretora.length <= 255 &&
                //self.segurosAnteriores.corretora != "" && 
                //self.segurosAnteriores.vencimento != "" &&
                (self.taxaDescontoAnteriorRadioStr != null && //Desativação da taxa e desconto
                ((self.segurosAnteriores.descontoApoliceAnterior >= 0 && self.segurosAnteriores.descontoApoliceAnterior <=100 && self.taxaDescontoAnteriorRadioStr == 'desconto') || 
                (self.segurosAnteriores.taxaApoliceAnterior > 0 && self.segurosAnteriores.taxaApoliceAnterior <= 100  && self.taxaDescontoAnteriorRadioStr == 'taxa'))) &&
                self.segurosAnteriores.coberturaRoubo != null && 
                ((self.segurosAnteriores.taxaRouboApoliceAnterior > 0 && self.segurosAnteriores.taxaRouboApoliceAnterior <= 100 && self.segurosAnteriores.coberturaRoubo == true) || 
                self.segurosAnteriores.coberturaRoubo == false) &&
                (self.segurosAnteriores.ocorreuSinistro != null &&
                ((self.segurosAnteriores.sinistros.length > 0) || self.segurosAnteriores.ocorreuSinistro == false));            
        } else {
            self.formValidSegurosAnteriores = 
                (((self.segurosAnteriores.ocorreuSinistro && self.segurosAnteriores.sinistros.length > 0) ||
                 !self.segurosAnteriores.ocorreuSinistro) && self.apoliceAnterioresStr == 'false');
        }
        if (self.apoliceAnterioresStr == null || self.ocorreuSinistroStr == null) {
            self.formValidSegurosAnteriores = false;
        }
        return this.formValidSegurosAnteriores && validaOcorrenciaSinistro;
    }
  },
  watch: {
    apoliceAnterioresStr: function (val) {
        this.segurosAnteriores.apoliceAnteriores = val == 'true';
        if (val == 'false') {
            this.resetFormApoliceAnterior();
        }
    },
    taxaDescontoAnteriorRadioStr: function (val) { //Desativação dos campos taxa e desconto
        if (val == 'taxa') {
            this.modelFormatado.descontoApoliceAnterior = "0";
            this.segurosAnteriores.descontoApoliceAnterior = 0.0;
        } else if (val == 'desconto') {
            this.modelFormatado.taxaApoliceAnterior = "0";
            this.segurosAnteriores.taxaApoliceAnterior = 0.0;
        } else {
            this.modelFormatado.taxaApoliceAnterior = "0";
            this.segurosAnteriores.taxaApoliceAnterior = 0.0;
            this.modelFormatado.descontoApoliceAnterior = "0";
            this.segurosAnteriores.descontoApoliceAnterior = 0.0;
        }
    },
    coberturaRouboStr: function (val) {
        const self = this;
        switch (val) {
            case 'true':
                self.segurosAnteriores.coberturaRoubo = true;
                break;
            case 'false':
                self.segurosAnteriores.taxaRouboApoliceAnterior = 0.0;
                self.$refs.txtSegurosAnterioresTaxaRouboApoliceAnteriorRef.$el.getElementsByTagName('input')[0].value = 0.00;
                self.$refs.txtSegurosAnterioresTaxaRouboApoliceAnteriorRef.reset();
                self.segurosAnteriores.coberturaRoubo = false;
                break;
            default:
                self.segurosAnteriores.coberturaRoubo = null;
                break;
        }
    },
    ocorreuSinistroStr: function (val) {
        this.segurosAnteriores.ocorreuSinistro = val == 'true';
    },
    'segurosAnteriores.vencimento': function (val) {
        this.modelFormatado.dataVencimento = CustomFormat.toLocaleDateString(val);
    },
    'modelFormatado.taxaApoliceAnterior': function (val) {
        this.segurosAnteriores.taxaApoliceAnterior = CustomFormat.removePercentFormat(val);
    },
    'modelFormatado.descontoApoliceAnterior': function (val) {
        this.segurosAnteriores.descontoApoliceAnterior = CustomFormat.removePercentFormat(val);
    },
    'modelFormatado.taxaRouboApoliceAnterior': function (val) {
        this.segurosAnteriores.taxaRouboApoliceAnterior = CustomFormat.removePercentFormat(val);
    },
    'modelFormatado.valorPrejuizoSinistro': function (val) {
        this.modelSinistro.valorPrejuizo = CustomFormat.removeMoneyFormat(val);
    },
    'modelSinistro.data': function (val) {
        this.modelFormatado.dataSinistro = val ? CustomFormat.toLocaleDateString(val) : '';
    },
    'modelSinistro.estado.id': function (val) {
        //this.carregaCidades();
    }
  },
  mounted: function () {
      this.resetDataHoraInicio();
      this.carregaMercadorias();
      //this.carregaEstados();
  },
  methods: {
    usarQuestionarioPai: function (param) {
        const self = this;
        self.questionarioPai = param;        
        self.segurosAnteriores = self.questionarioPai;
        self.apoliceAnterioresStr = self.questionarioPai.apolicesAnteriores.toString();

        if (self.apoliceAnterioresStr == 'true') {
            if (self.questionarioPai.taxaApoliceAnterior > 0) {
                self.taxaDescontoAnteriorRadioStr = 'taxa';
                self.modelFormatado.taxaApoliceAnterior = CustomFormat.pontoParaVirgula(self.questionarioPai.taxaApoliceAnterior.toFixed(3));
            } else if(self.questionarioPai.descontoApoliceAnterior) { //Desativação dos campos taxa e desconto
                self.taxaDescontoAnteriorRadioStr = 'desconto';
                self.modelFormatado.descontoApoliceAnterior = CustomFormat.pontoParaVirgula(self.questionarioPai.descontoApoliceAnterior.toFixed(2));
            }
            if (self.questionarioPai.taxaRouboApoliceAnterior > 0) {
                self.coberturaRouboStr = 'true';
                self.modelFormatado.taxaRouboApoliceAnterior = CustomFormat.pontoParaVirgula(self.questionarioPai.taxaRouboApoliceAnterior.toFixed(3));
            } else {
                self.coberturaRouboStr = 'false';
            }
        }
        self.ocorreuSinistroStr = self.questionarioPai.ocorreuSinistro.toString();
        
        //if (self.ocorreuSinistroStr == 'true'){
        //    self.getEstadoCidadePorId();
        //}
    },
    getEstadoCidadePorId: async function () {
        const self = this;
        var idEstado;
        var idCidade;
        for (var i = 0; i < self.segurosAnteriores.sinistros.length; i++) {
            idEstado = self.segurosAnteriores.sinistros[i].estado;
            idCidade = self.segurosAnteriores.sinistros[i].cidade;

            await axios.get(`${process.env.URL_GEOMS}/v1/no-auth/buscaEstado?id=${idEstado}`)
            .then((response) => {
                self.segurosAnteriores.sinistros[i].estado = response.data;
            });
            
            await axios.get(`${process.env.URL_GEOMS}/v1/no-auth/buscaCidadePorId?idcidade=${idCidade}`)
            .then((response) => {
                self.segurosAnteriores.sinistros[i].cidade = response.data.cidadeModel;
            });
        }
    },
    resetDataHoraInicio: function () {
        this.dataHoraInicio = new Date();
    },
    somaTempoPreenchimentoTotal: function () {
        const self = this;
        var dateTimeNow = new Date();
        if (self.tempoPreenchimentoTotal == '') {
            self.tempoPreenchimentoTotal = parseInt(((dateTimeNow.getTime()/1000)/60) - ((self.dataHoraInicio.getTime()/1000)/60));
        } else {
            self.tempoPreenchimentoTotal += (parseInt(((dateTimeNow.getTime()/1000)/60) - ((self.dataHoraInicio.getTime()/1000)/60)));
        }
    },
    carregaMercadorias: function () {
        const self = this;

        axios.get(`${process.env.URL_MERCADORIAMS}/v1/no-auth/buscaTodasMercadorias`)
          .then((response) => {
            const data = response.data;
            if (data) {
                self.lstMercadorias = data.filter((obj) => {
                    return (obj.id != 279);
                });
            }
          }).catch((err) => {
            console.log(err);
          });
    },
    carregaEstados: function () {
        const self = this;
        axios.get(`${process.env.URL_GEOMS}/v1/no-auth/buscaTodosEstados`)
        .then((response) => {
            self.estados = response.data.sort((a, b) => { return a.sigla.localeCompare(b.sigla) })
            .filter((obj) => {
                return (obj.id != 28);
            });
        });
    },
    carregaCidades: function () {
        const self = this;
        if(self.modelSinistro.estado.id) {
            axios.get(`${process.env.URL_GEOMS}/v1/no-auth/buscaCidadesDeUmEstado?idestado=${self.modelSinistro.estado.id}`)
            .then((response) => {
                self.cidades = response.data.sort((a, b) => { return a.nome.localeCompare(b.nome) })
            });
        }
    },
    toMoneyString: function (val) {
        return CustomFormat.toMoneyString(val);
    },
    toLocaleDateString: function (val) {
        return CustomFormat.toLocaleDateString(val);
    },
    removeSinistro: function (item) {
        let index = this.segurosAnteriores.sinistros.indexOf(item);
        this.segurosAnteriores.sinistros.splice(index, 1);
    },
    validaAddSinistro: function () {
        const self = this;
        let erro = false;
        
        self.errorMessages.valorPrejuizo = [];
        if (self.modelSinistro.valorPrejuizo == 0) {
            erro = erro || true;
            self.errorMessages.valorPrejuizo = ['Você precisa informar um valor válido'];
        }

        self.errorMessages.mercadoria = [];
        if (Object.keys(self.modelSinistro.mercadoria).length === 0) {
            erro = erro || true;
            self.errorMessages.mercadoria = ['Você não pode deixar este campo em branco'];
        }

        self.errorMessages.causaDoSinistro = [];
        if (!self.modelSinistro.causaDoSinistro) {
            erro = erro || true;
            self.errorMessages.causaDoSinistro = ['Você não pode deixar este campo em branco'];
        }

        //self.errorMessages.estado = [];
        //if (!self.modelSinistro.estado.id) {
        //    erro = erro || true;
        //    self.errorMessages.estado = ['Você não pode deixar este campo em branco'];
        //}

        //self.errorMessages.cidade = [];
        //if (!self.modelSinistro.cidade.id) {
        //    erro = erro || true;
        //    self.errorMessages.cidade = ['Você não pode deixar este campo em branco'];
        //}

        self.errorMessages.data = [];
        if (!self.modelSinistro.data) {
            erro = erro || true;
            self.errorMessages.data = ['Você não pode deixar este campo em branco'];
        }

        //self.errorMessages.obs = [];
        //if (!self.modelSinistro.obs) {
        //    erro = erro || true;
        //    self.errorMessages.obs = ['Você não pode deixar este campo em branco'];
        //}

        return !erro;
    },
    limpaCamposSinistro: function () {
        const self = this;
        self.modelSinistro.mercadoria = {};
        self.modelSinistro.causaDoSinistro = '';
        self.modelSinistro.data = '';
        self.modelSinistro.estado = null;
        self.modelSinistro.cidade = null;
        self.modelSinistro.obs = null;
        self.$refs.txtValorSinistro.$el.getElementsByTagName('input')[0].value = 0;
    },
    adicionaSinistro: function () {
        const self = this;

        if (self.validaAddSinistro()) {
            self.segurosAnteriores.sinistros.push(Object.assign({}, self.modelSinistro));
            self.limpaCamposSinistro();
        }
    },
    montaModelo: function () {
        const self = this;
        let modelo = {};

        modelo.apolicesAnteriores = self.segurosAnteriores.apoliceAnteriores;
        if (modelo.apolicesAnteriores) {
            modelo.seguradora = self.segurosAnteriores.seguradora;
            modelo.corretora = self.segurosAnteriores.corretora;
            modelo.vencimento = self.segurosAnteriores.vencimento;
            modelo.coberturaRoubo = self.segurosAnteriores.coberturaRoubo;
            modelo.taxaApoliceAnterior = self.segurosAnteriores.taxaApoliceAnterior;
            modelo.descontoApoliceAnterior = self.segurosAnteriores.descontoApoliceAnterior;

            if (modelo.coberturaRoubo){
                modelo.taxaRouboApoliceAnterior = self.segurosAnteriores.taxaRouboApoliceAnterior;
            }
        }

        modelo.ocorreuSinistro = self.segurosAnteriores.ocorreuSinistro;
        if (modelo.ocorreuSinistro) {
            //self.segurosAnteriores.sinistros.forEach(sinistro => {
            //    sinistro.estado = sinistro.estado.id;
            //    sinistro.cidade = sinistro.cidade.id;
            //});
            modelo.sinistros = self.segurosAnteriores.sinistros;
        }

        return modelo;
    },
    zeraTaxaDescontoAnteriorTextField: function () { //Desativação dos campos taxa e desconto
        const self = this;
        if (self.taxaDescontoAnteriorRadioStr == 'taxa') {
            if (!!document.getElementById('txtSegurosAnterioresDescontoApoliceAnterior')) {
                self.$refs.txtSegurosAnterioresDescontoApoliceAnteriorLabel.$el.getElementsByTagName('input')[0].value = 0.00;
                self.$refs.txtSegurosAnterioresDescontoApoliceAnteriorLabel.reset();
            }
        } else if (self.taxaDescontoAnteriorRadioStr == 'desconto') {
            if (!!document.getElementById('txtSegurosAnterioresTaxaApoliceAnterior')) {
                self.$refs.txtSegurosAnterioresTaxaApoliceAnteriorLabel.$el.getElementsByTagName('input')[0].value = 0.000;
                self.$refs.txtSegurosAnterioresTaxaApoliceAnteriorLabel.reset();
            }
        }
    },
    resetFormApoliceAnterior: function () {
        const self = this;
        self.segurosAnteriores.apoliceAnteriores = false;
        
        self.$refs.txtSegurosAnterioresSeguradoraRef.reset();
        self.segurosAnteriores.seguradora = '';
        self.$refs.txtSegurosAnterioresCorretoraRef.reset();
        self.segurosAnteriores.corretora = '';
        
        self.segurosAnteriores.vencimento = null;

        self.segurosAnteriores.taxaApoliceAnterior = 0.0;
        self.$refs.txtSegurosAnterioresTaxaApoliceAnteriorLabel.$el.getElementsByTagName('input')[0].value = 0.000;
        self.$refs.txtSegurosAnterioresTaxaApoliceAnteriorLabel.reset();
        
        self.segurosAnteriores.descontoApoliceAnterior = 0.0;
        self.$refs.txtSegurosAnterioresDescontoApoliceAnteriorLabel.$el.getElementsByTagName('input')[0].value = 0.00;
        self.$refs.txtSegurosAnterioresDescontoApoliceAnteriorLabel.reset();
        
        self.$refs.taxaDescontoAnteriorRadioRef.reset();
        self.taxaDescontoAnteriorRadioStr = null; //Desativação dos campos taxa e desconto
        
        self.segurosAnteriores.taxaRouboApoliceAnterior = 0.0;
        self.$refs.txtSegurosAnterioresTaxaRouboApoliceAnteriorRef.$el.getElementsByTagName('input')[0].value = 0.00;
        self.$refs.txtSegurosAnterioresTaxaRouboApoliceAnteriorRef.reset();
   
        
        self.$refs.taxaRouboAnteriorRadioRef.reset();
        self.segurosAnteriores.coberturaRoubo = null;
        self.coberturaRouboStr = null;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/questionario/SegurosAnterioresQ.vue